
let accordion = [
  {
    'title':'What enclosure is best for LoRaWAN gateways? ',
    'description':`For outdoor LoRaWAN gateways, choose an IP67-rated enclosure with antenna feedthroughs and sufficient internal space for gateway hardware and cabling. Gateway-capable outdoor enclosures provide better weather protection and mounting flexibility for long-term deployments.`
  },
  {
    'title':'What makes an enclosure IP65 or IP67 rated?',
    'description':`IP65 protects against dust and low-pressure water jets. IP67 protects against dust and immersion in water up to 1 meter for 30 minutes.`
  },
  {
    'title':'Is IP65 or IP67 better for outdoor IoT deployments?',
    'description':`IP65 enclosures protect against dust and water jets, making them suitable for sheltered outdoor locations. IP67 enclosures provide full dust protection and temporary water immersion resistance, making them ideal for exposed or harsh environments.`
  },
  {
    'title':'Can these enclosures house WisBlock and Raspberry Pi devices?',
    'description':`Yes. Many enclosure models include mounting plates and universal layouts compatible with WisBlock Base Boards and Raspberry Pi.`
  },
  {
    'title':'Do I need a connector-ready enclosure?',
    'description':`Connector-ready enclosures are recommended when deploying devices outdoors or at scale. Pre-drilled antenna ports and cable access reduce installation time, minimize sealing errors, and improve long-term reliability.`
  },
  {
    'title':'Do these enclosures support integrated antennas?',
    'description':`Some variants include integrated LoRa® and Bluetooth antennas for compact deployments.`
  },
  {
    'title':'What antenna connector type should I choose?',
    'description':`SMA connectors are commonly used for compact IoT devices and gateways, while N-Type connectors offer better durability for permanent outdoor installations. The right choice depends on your antenna type and deployment environment.`
  },
  {
    'title':'Are mounting accessories included?',
    'description':`Mounting kits are available separately. Universal pole mounts and solar shields are provided for outdoor use cases.`
  },
]

  
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": accordion.map(item => ({
    "@type": "Question",
    "name": item.title,
    "acceptedAnswer": {
      "@type": "Answer",
      // Strip HTML tags for schema compliance
      "text": item.description.replace(/<[^>]*>/g, "").trim()
    }
  }))
};
const script = document.createElement("script");
script.type = "application/ld+json";
script.textContent = JSON.stringify(faqSchema);
document.head.appendChild(script);


$(document).ready(function(){

  

  let accordion_html = ''

  accordion.map(a=>{
    accordion_html+=`
      <div class="accordion__container">
        <div class="accordion">
          <h3>${a.title}</h3>
          <img src="https://cdn.shopify.com/s/files/1/0177/8784/6756/files/accordion.svg?v=1723128392" class="arrow"/>
        </div>
        <div class="panel">
          ${a.description}
        </div>
      </div>
    `
  })

  $('.accordions').html(accordion_html)

  
  $('.accordion').on('click',function(){
    $(this).next().toggle()
    if($(this).next().is(":visible"))
      $(this).find('.arrow').css('transform' , 'rotate(0deg)');
    else
      $(this).find('.arrow').css('transform' , 'rotate(180deg)');
  })


  
  const swiper_collection = new Swiper('.collection .swiper',{
      enabled:true,
      slidesPerView:2,
      spaceBetween:0,
      freeMode: true,
      slidesOffsetAfter:180,
      breakpoints: {
        769: {
          slidesPerView:5,
          enabled:false
        }
      }
      
  });
 

})